<template>
    <div>
        <div v-for="(techSpecListWithinCategory, techSpecCategory) in techSpecs" :key="techSpecCategory + '.techItems'">
            <ul class="reuseable-faq__ul">
                <li class="reuseable-faq__li">
                    <button type="button" @click="selectCategory(techSpecCategory)" class="reuseable-faq__item reuseable-faq__toggle" :aria-expanded="techSpecSelected == techSpecCategory">
                        <h3 class="reuseable-faq__title" v-html="techSpecCategory" />
                        <img src="/images/link-icon.svg" class="reuseable-faq__toggle-icon" :class="{'reuseable-faq__toggle-icon--in': techSpecSelected == techSpecCategory }" />
                    </button>

                    <CollapseTransition>
                        <div v-show="techSpecSelected == techSpecCategory" class="reuseable-faq__content new-details__spec-item-container">
                            <div v-for="specItem in techSpecListWithinCategory" :key="'techItem.' + specItem.id" class="new-details__spec-item">
                                <span class="new-details__spec-item-name">{{ specItem.name }}</span>
                                <span class="new-details__spec-item-value">{{ specItem.value }}</span>
                            </div>
                        </div>
                    </CollapseTransition>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { CollapseTransition } from "vue2-transitions";

export default {
    components: {
        CollapseTransition,
    },
    data() {
        return {
            techSpecSelected: null,
        };
    },
    methods: {
        selectCategory(categoryToSelect) {
            if (this.techSpecSelected == categoryToSelect) {
                this.techSpecSelected = null;
                return;
            }
            this.techSpecSelected = categoryToSelect;
        }
    },
    computed: {
        ...mapState('NewVehicleData', ['techSpecs']),
    },
    created() {
        // this.techSpecSelected = Object.keys(this.techSpecs)[0];
    }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// resources/assets/js/new-vue/components/details/TechSpecs.vue